/* eslint-disable */
import request, { apiHost, config } from '../utils/request';
import axios from 'axios';
import { isWithinInterval } from 'date-fns';
import history from '../history';
import { get, intersection, omit } from 'lodash';
import {
  orderStatus,
  quoteStatus,
  fieldWinbackFibre,
  valueNewTelusBusinessOrder,
  reasonForSubOptionsEN,
  reasonForSubOptionsFR,
  WLSPendingValidationReasons,
  WLSRestrictedChannelsForOrderCreation,
  fieldSubmittingOnBehalfOf,
  fieldSubmittingOnBehalfOfVulcan,
  vulcanLandingPage
} from '../utils/constant';
import { checkProperties } from '../utils';
import { getLocale } from '../misc';
import EN from '../../EN.json';
import FR from '../../FR.json';

const numberOfSubscribersOrderedIs16Plus = [
  EN.formStep.subscribers16Plus,
  FR.formStep.subscribers16Plus
];

const devicesOnly = [EN.formStep.devicesOnly, FR.formStep.devicesOnly];

const expiredOffers = WLSPendingValidationReasons.ExpiredOffers;

export const submitFile = async (payload, filesPayload, orderId) => {
  if (!filesPayload) return;

  let filesData = filesPayload;
  const orderPayload = payload;
  if (!Array.isArray(filesPayload)) {
    filesData = Object.entries(filesPayload).map(([, value]) => value);
  }
  const formData = new FormData();
  filesData.map(fileDetails =>
    Object.values(fileDetails).map(file => {
      formData.append(`${Object.keys(fileDetails)[0]}`, file);
    })
  );
  if (payload.portingInformation) {
    formData.append('portingInformation', payload.portingInformation);
  }
  formData.append('tollFree', payload.tollFree);
  await request.put(`/orders/${orderId}`, formData);
  delete orderPayload.files;
};

const convertStringToJSON = subscriberDetails => {
  subscriberDetails.forEach((item, index) => {
    try {
      // eslint-disable-next-line no-param-reassign
      subscriberDetails[index].subscriberDetailsDevices = JSON.parse(
        item.subscriberDetailsDevices
      );
      // eslint-disable-next-line no-empty
    } catch (e) {}
  });
  return subscriberDetails;
};

const shouldBypassPendingValidation = orderPermissions => {
  const bypassPendingValidation = orderPermissions.find(
    orderPermission => orderPermission.id === 1
  );

  const bypassPendingValidationEnabled =
    bypassPendingValidation && bypassPendingValidation.isEnabled;

  const bypassPendingValidationDates =
    bypassPendingValidation &&
    bypassPendingValidation.isEnabled &&
    bypassPendingValidation.startDate &&
    bypassPendingValidation.endDate
      ? [bypassPendingValidation.startDate, bypassPendingValidation.endDate]
      : null;

  return bypassPendingValidationDates
    ? isWithinInterval(new Date(), {
        start: new Date(bypassPendingValidationDates[0]),
        end: new Date(bypassPendingValidationDates[1])
      })
    : bypassPendingValidationEnabled;
};

const shouldBypassPendingValidationForLNR = orderData => {
  return orderData.reasonForSubmission === 'LNR Webform';
};

export const wlsSubmitPayload = (
  formData,
  isFormLastStep,
  orderPermissions
) => {
  const payload = { ...formData };

  if (formData.id) {
    const { id, files } = formData;
    payload.subscriberDetails =
      payload.subscriberDetails && payload.subscriberDetails.length
        ? convertStringToJSON(payload.subscriberDetails)
        : [];

    if (isFormLastStep) {
      payload.status = orderStatus.validated;
      // commented because applied similar updated logic under this
      // if (
      //   (WLSPendingValidationReasons.MSSDefect.includes(
      //     payload.reasonForSubmission
      //   ) &&
      //     WLSPendingValidationReasons.MSSDefectTeam.includes(
      //       payload.mssDefectTeam
      //     )) ||
      //   (WLSPendingValidationReasons.OrderIsNOTEligibleForMSS.includes(
      //     payload.reasonForSubmission
      //   ) &&
      //     payload.orderNotEligibleforMssReason.filter(reason =>
      //       WLSPendingValidationReasons.OrderIsNotEligibleForMSSReasons.includes(
      //         reason
      //       )
      //     ).length > 0) ||
      //   WLSPendingValidationReasons.ExpiredOffers.includes(
      //     payload.reasonForSubmission
      //   ) ||
      //   WLSPendingValidationReasons.RequiresDirectorApproval.includes(
      //     payload.requiresDirectorsApproval
      //   )
      // ) {
      //   payload.status = orderStatus.pendingValidation;
      // }
      payload.wlsTotalOneTimeCost =
        localStorage.getItem('wlsTotalOneTimeCost') || '0.00';
      payload.wlsTotalMonthlyCost =
        localStorage.getItem('wlsTotalMonthlyCost') || '0.00';

      const reasonsToSubmitOrderDirectly =
        formData.mssDefectTeam === 'SMB Sales' ||
        (Array.isArray(formData.orderNotEligibleforMssReason)
          ? !!intersection(formData.orderNotEligibleforMssReason, [
              ...numberOfSubscribersOrderedIs16Plus,
              ...devicesOnly
            ]).length
          : false || expiredOffers.includes(formData.reasonForSubmission));

      // const restrictedChannel = WLSRestrictedChannelsForOrderCreation.includes(
      //   channelName
      // );
      //isChannelBcxLoyaltyOrSBS will check whether channel is from restricted channel list i.e. BCX/BCX Care/BCX HD

      const isChannelBcxLoyaltyOrSBS =
        formData.channel && Array.isArray(formData.channel)
          ? formData.channel.includes(channel =>
              WLSRestrictedChannelsForOrderCreation.includes(channel.name)
            )
          : formData.channel && formData.channel.name
          ? WLSRestrictedChannelsForOrderCreation.includes(
              formData.channel.name
            )
          : false;

      if (
        !isChannelBcxLoyaltyOrSBS &&
        reasonsToSubmitOrderDirectly &&
        !shouldBypassPendingValidation(orderPermissions)
      ) {
        payload.status = orderStatus.pendingValidation;
      }
      if (shouldBypassPendingValidationForLNR(formData)) {
        payload.status = orderStatus.validated;
      }
    }
    if (
      payload.reasonForSubmission !== reasonForSubOptionsEN[3] &&
      payload.reasonForSubmission !== reasonForSubOptionsFR[3]
    ) {
      if (files && [6].includes(payload.step)) {
        submitFile(payload, files, id);
      }
    } else {
      if ([2].includes(payload.step)) {
        submitFile(payload, files, id);
      }
      if (
        [6].includes(payload.step) &&
        payload.files &&
        payload.files.length > 1
      ) {
        submitFile(payload, files, id);
      }
    }
    return axios.put(`${apiHost}/orders/${id}`, payload, config());
  }
  payload.typeOfOrder = 'WLS';
  payload.status = orderStatus.incomplete;
  return axios.post(`${apiHost}/orders`, payload, config());
};

export const fmSubmitPayload = (formData, isFormLastStep) => {
  const payload = { ...formData };

  if (formData.id) {
    const { id, files, attachmentFile } = formData;
    if (isFormLastStep) {
      payload.status = orderStatus.pendingValidation;
    }
    if (files && [2].includes(payload.step)) {
      console.log(files);
      submitFile(payload, files, id);
    }
    if (attachmentFile && [2].includes(payload.step)) {
      console.log(attachmentFile);
      submitFile(payload, attachmentFile, id);
    }
    return axios.put(`${apiHost}/orders/${id}`, payload, config());
  }
  payload.typeOfOrder = 'FM';
  payload.status = orderStatus.incomplete;
  payload.step = 1;
  return axios.post(`${apiHost}/orders`, payload, config());
};

export const csSubmitPayload = (formData, isFormLastStep) => {
  const payload = { ...formData };

  if (formData.id) {
    const { id, files, attachmentFile } = formData;
    if (isFormLastStep) {
      payload.status = orderStatus.submitted;
    }
    if (files && [2].includes(payload.step)) {
      console.log(files);
      submitFile(payload, files, id);
    }
    if (attachmentFile && [2].includes(payload.step)) {
      console.log(attachmentFile);
      submitFile(payload, attachmentFile, id);
    }
    return axios.put(`${apiHost}/orders/${id}`, payload, config());
  }
  payload.typeOfOrder = 'CS';
  payload.status = orderStatus.incomplete;
  payload.step = 1;
  const profile = request.getProfile();
  if (profile && profile.role && profile.role.name === 'SALES_MANAGER') {
    payload.salesManagerName = `${profile.firstName} ${profile.lastName}`;
  }
  return axios.post(`${apiHost}/orders`, payload, config());
};

const getSelectedSalesRepPayload = submittingOnBehalfOf => {
  if (['Yes', 'Oui'].includes(submittingOnBehalfOf)) {
    const selectedSalesRep = JSON.parse(
      localStorage.getItem('salesRepInfoForSRT')
    );
    if (selectedSalesRep) {
      return {
        ...omit(selectedSalesRep, [
          'id',
          'province',
          'status',
          'createdAt',
          'updatedAt'
        ]),
        channelId: get(selectedSalesRep, 'channels.0.id', '')
      };
    }
  } else if (['No', 'Non'].includes(submittingOnBehalfOf)) {
    localStorage.removeItem('salesRepInfoForSRT');
  }
  return {};
};

export const vulcanSubmitPayload = (formData, isFormLastStep) => {
  const payload = {
    ...formData,
    ...getSelectedSalesRepPayload(formData[fieldSubmittingOnBehalfOfVulcan])
  };
  // The landing page's "New Order" always creates a new order. A stale id
  // there (e.g. after browser Back from Vulcan_Form) used to PUT the previous
  // order as SUBMITTED and fire its one-time summary email.
  if (formData.formName === vulcanLandingPage) {
    delete payload.id;
    delete payload.completedAt;
  } else if (formData.id) {
    const { id, files, attachmentFile } = formData;
    if (isFormLastStep) {
      payload.completedAt = new Date();
      payload.status = orderStatus.submitted;
    }
    if (files && [2].includes(payload.step)) {
      console.log(files);
      submitFile(payload, files, id);
    }
    if (attachmentFile && [2].includes(payload.step)) {
      console.log(attachmentFile);
      submitFile(payload, attachmentFile, id);
    }
    return axios.put(`${apiHost}/orders/${id}`, payload, config());
  }
  payload.typeOfOrder = 'VUL';
  payload.status = orderStatus.incomplete;
  payload.step = 1;
  return axios.post(`${apiHost}/orders`, payload, config());
};

export const fmSOWSubmitPayload = (formData, isFormLastStep) => {
  const payload = { ...formData };

  if (formData.id) {
    const { id, files, attachmentFile } = formData;
    if (isFormLastStep) {
      payload.status = orderStatus.pendingValidation;
    }
    if (files && [2].includes(payload.step)) {
      console.log(files);
      submitFile(payload, files, id);
    }
    if (attachmentFile && [2].includes(payload.step)) {
      console.log(attachmentFile);
      submitFile(payload, attachmentFile, id);
    }
    return axios.put(`${apiHost}/orders/${id}`, payload, config());
  }
  payload.typeOfOrder = 'SOW';
  payload.status = orderStatus.incomplete;
  payload.step = 1;
  return axios.post(`${apiHost}/orders`, payload, config());
};

export const ocdrSubmitPayload = (formData, isFormLastStep) => {
  const payload = {
    ...formData,
    ...getSelectedSalesRepPayload(formData[fieldSubmittingOnBehalfOf])
  };
  if (formData.id) {
    const { id, files, attachmentFile } = formData;
    if (isFormLastStep) {
      if (formData.isQuoteApproveRequired) {
        payload.status = quoteStatus.pendingApproval;
      } else {
        payload.status = quoteStatus.approved;
      }
    } else {
      payload.status = orderStatus.incomplete;
    }
    if (files && [2].includes(payload.step)) {
      console.log(files);
      submitFile(payload, files, id);
    }
    if (attachmentFile && [2].includes(payload.step)) {
      console.log(attachmentFile);
      submitFile(payload, attachmentFile, id);
    }
    return axios.put(`${apiHost}/orders/${id}`, payload, config());
  }
  const profile = request.getProfile();
  const { channelName } = profile;
  payload.typeOfOrder = 'OCDR';
  if (!payload.channelName) {
    payload.channelName = channelName ? channelName : '';
  }
  payload.status = orderStatus.incomplete;
  payload.step = 1;
  return axios.post(`${apiHost}/orders`, payload, config());
};

export const brpSubmitPayload = (formData, isFormLastStep) => {
  const payload = { ...formData };
  if (formData.id) {
    const { id } = formData;
    if (isFormLastStep) {
      payload.status = orderStatus.submitted;
    }
    return axios.put(`${apiHost}/brp/${id}`, payload, config());
  }

  payload.status = orderStatus.incomplete;
  return axios.post(`${apiHost}/brp`, payload, config());
};

/*eslint no-param-reassign: "error"*/
export const saveAndExit = (payload, shouldExit = true) => {
  const locale = getLocale();
  const { id, files } = payload;
  if (
    payload.emergencyContactDetails &&
    payload.emergencyContactDetails.length > 0
  ) {
    const isEmpty = checkProperties(payload.emergencyContactDetails[0]);
    if (isEmpty) {
      delete payload.emergencyContactDetails;
    }
  }
  let step = 0;
  if (payload.productSelection) {
    step = payload.productSelection.length + 5;
  }
  if (payload.step === step) {
    if (payload.secureBusinessOffers) {
      if (payload.secureBusinessOffers.includes('6monthFree')) {
        const index = payload.secureBusinessOffers.indexOf('6monthFree');
        payload.secureBusinessOffers[index] = 'sixMonthsFree';
      }
    }
    if (payload.telusOptikTvPromoDuration) {
      if (payload.telusOptikTvPromoDuration === '6 months optik') {
        payload.telusOptikTvPromoDuration = '6 months optik';
      }
    }
    if (payload.promoDuration) {
      if (payload.promoDuration === '6months') {
        payload.promoDuration = 'sixMonths';
      }
    }
    if (payload.promoDurationFibre) {
      if (
        payload.promoDurationFibre === '6months' ||
        payload.promoDuration === '6months'
      ) {
        payload.promoDurationFibre = 'sixMonths';
      }
    }
    if (
      payload.telusSecureBusinessSecurityPackage &&
      payload.telusSecureBusinessSecurityPackage === 'Control'
    ) {
      payload.controlIncludedEquipment = {
        ...payload.controlIncludedEquipment,
        ...payload.controlIncludedEquipmentSelection
      };
      delete payload.protectIncludedEquipmentSelection;
      delete payload.controlIncludedEquipmentSelection;
    }
    if (
      payload.telusSecureBusinessSecurityPackage &&
      payload.telusSecureBusinessSecurityPackage === 'Protect'
    ) {
      payload.protectIncludedEquipment = {
        ...payload.protectIncludedEquipment,
        ...payload.protectIncludedEquipmentSelection
      };
      delete payload.controlIncludedEquipmentSelection;
      delete payload.protectIncludedEquipmentSelection;
    }
  }
  if (payload.orderType && payload.orderType !== valueNewTelusBusinessOrder) {
    delete payload[fieldWinbackFibre];
  }
  payload.parsedProvince = localStorage.getItem('province');
  payload.dealership =
    JSON.parse(localStorage.getItem('userProfile')) &&
    JSON.parse(localStorage.getItem('userProfile')).dealership;
  if (payload.doesCustomerHaveLawnOrFenceOnPremise) {
    payload.doesCustomerHaveLawnOrFenceOnPremise = [
      payload.doesCustomerHaveLawnOrFenceOnPremise
    ].join();
  }
  const putPayload = Object.assign({}, payload);
  submitFile(putPayload, files, id);
  request.put(`/orders/${id}`, putPayload).then(() => {
    if (putPayload.categoryName === 'wireless') {
      history.push(`/${locale}/wireless/Wireless_Landing_Page?page=1`);
      window.location.reload();
    } else if (putPayload.categoryName === 'fully_managed' && shouldExit) {
      history.push(
        `/${locale}/fully_managed/Fully_Managed_Landing_Page?page=1`
      );
      window.location.reload();
    } else if (putPayload.categoryName === 'vulcan') {
      history.push(`/${locale}/vulcan/Vulcan_Landing_Page?page=1`);
      window.location.reload();
    } else if (putPayload.categoryName === 'fully_managed_SOW') {
      history.push(
        `/${locale}/fully_managed_SOW/Fully_Managed_SOW_Landing_Page?page=1`
      );
      window.location.reload();
    } else if (putPayload.categoryName === 'OCDR') {
      history.push(`/${locale}/OCDR/OCDR_Landing_Page?page=1`);
      window.location.reload();
    } else if (putPayload.categoryName === 'cybersecurity') {
      history.push(
        `/${locale}/cybersecurity/Cybersecurity_Landing_Page?page=1`
      );
      window.location.reload();
    } else if (shouldExit) history.push('/');
  });
};
